import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0323bcc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-header" }
const _hoisted_2 = { class: "col--12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "btn-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Log out", -1))
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createVNode(_component_BaseSvg, { icon: 'account/avatar' }),
      _createElementVNode("span", null, "Hi, " + _toDisplayString(_ctx.user.firstName.toLowerCase()) + " " + _toDisplayString(_ctx.user.lastName?.toLowerCase() ?? ""), 1)
    ]),
    (_ctx.user.type === _ctx.UserType.Agent)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "Agent account"))
      : _createCommentVNode("", true),
    (_ctx.user.type !== _ctx.UserType.Agent)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "Customer account"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_BaseButton, {
        loading: _ctx.loading,
        onClick: _ctx.logout,
        class: "logout button--white"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BaseSvg, { icon: "account/log-out" }),
          _hoisted_6
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    _createElementVNode("nav", null, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.newBooking && _ctx.newBooking(...args)))
        }, "New booking"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (component, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass({ active: component.number === _ctx.currentPage.number}),
            onClick: ($event: any) => (_ctx.goToPage(component.number))
          }, _toDisplayString(component.name), 11, _hoisted_7))
        }), 128))
      ])
    ])
  ]))
}